module.exports = __webpack_public_path__ + "media/images/flags/br-7e384ba6bba38efc8087c4755f45c4da.svg";